"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var CircularProgress_1 = __importDefault(require("../CircularProgress"));
var virtualized_1 = __importDefault(require("./virtualized"));
var Select_1 = __importDefault(require("./Select"));
var SPINNER_SIZE = 24;
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    containProgress: {
        position: 'relative',
        display: 'inline-block',
        '&:after': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, .6)',
            zIndex: '100',
        },
    },
    spinner: {
        position: 'absolute',
        left: "calc(50% - ".concat(SPINNER_SIZE / 2, "px)"),
        top: "calc(50% - ".concat(SPINNER_SIZE / 2, "px)"),
        zIndex: 1001,
    },
    required: {
        color: theme.palette.error.main
    }
}); });
var SelectWrapper = function (_a) {
    var _b = _a.virtual, virtual = _b === void 0 ? false : _b, _c = _a.progress, progress = _c === void 0 ? false : _c, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.classes, classes = _e === void 0 ? { select: {}, formControl: {} } : _e, _f = _a.autoWidth, autoWidth = _f === void 0 ? false : _f, defaultValue = _a.defaultValue, _g = _a.displayEmpty, displayEmpty = _g === void 0 ? false : _g, IconComponent = _a.IconComponent, id = _a.id, inputProps = _a.inputProps, _h = _a.label, label = _h === void 0 ? null : _h, labelId = _a.labelId, _j = _a.labelWidth, labelWidth = _j === void 0 ? 0 : _j, MenuProps = _a.MenuProps, _k = _a.native, native = _k === void 0 ? false : _k, onChange = _a.onChange, onClose = _a.onClose, onOpen = _a.onOpen, open = _a.open, renderValue = _a.renderValue, SelectDisplayProps = _a.SelectDisplayProps, value = _a.value, _l = _a.variant, variant = _l === void 0 ? 'standard' : _l, fullWidth = _a.fullWidth, _m = _a.helperText, helperText = _m === void 0 ? '' : _m, _o = _a.multiple, multiple = _o === void 0 ? false : _o, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, placeholder = _a.placeholder, field = _a.field, _p = _a.items, items = _p === void 0 ? [] : _p, _q = _a.error, error = _q === void 0 ? false : _q, _r = _a.readOnly, readOnly = _r === void 0 ? false : _r, _s = _a.disabled, disabled = _s === void 0 ? false : _s, width = _a.width, height = _a.height, children = _a.children;
    var internalClasses = useStyles();
    var dataLabel = required ? (react_1.default.createElement("span", null,
        label,
        react_1.default.createElement("span", { className: internalClasses.required }, "\u2009*"))) : (label);
    var commonProps = {
        classes: classes,
        autoWidth: autoWidth,
        defaultValue: defaultValue,
        displayEmpty: displayEmpty,
        IconComponent: IconComponent,
        id: id,
        inputProps: inputProps,
        label: dataLabel,
        labelId: labelId,
        labelWidth: labelWidth,
        MenuProps: MenuProps,
        native: native,
        SelectDisplayProps: SelectDisplayProps,
        value: value,
        variant: variant,
        fullWidth: fullWidth,
        helperText: helperText,
        placeholder: placeholder,
        field: field,
        items: items,
        error: error,
        readOnly: readOnly,
        disabled: disabled,
        onChange: onChange,
        multiple: multiple,
        startAdornment: startAdornment,
        endAdornment: endAdornment
    };
    return (react_1.default.createElement("div", { className: progress ? internalClasses.containProgress : '' },
        progress && (react_1.default.createElement(CircularProgress_1.default, { size: SPINNER_SIZE, classes: { root: internalClasses.spinner } })),
        virtual ? (react_1.default.createElement(virtualized_1.default, __assign({}, commonProps, { width: width, height: height })))
            : (react_1.default.createElement(Select_1.default, __assign({}, commonProps, { onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue }), children))));
};
exports.default = SelectWrapper;
